import { dateStringFormatter } from '~/features/utils';
import { ContractDetail } from '../types';

interface Props {
  contract: ContractDetail;
  isProviderView?: boolean;
}

const formatCurrency = (value: string | null) => {
  if (!value) return '—';
  return `$${Number(value).toLocaleString()}`;
};

const calculateDuration = (start: string, end: string | null): string => {
  if (!end) return 'Open-ended';
  const startDate = new Date(start);
  const endDate = new Date(end);
  const months = Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24 * 30));
  if (months < 1) return 'Less than 1 month';
  if (months === 1) return '1 month';
  return `${months} months`;
};

const TermItem = ({ label, value }: { label: string; value: string }) => (
  <div className="p-2 bg-grey-900 rounded-lg">
    <p className="text-xs uppercase tracking-wide text-grey-500 mb-0.5">{label}</p>
    <p className="text-sm font-bold text-grey-50">{value}</p>
  </div>
);

export const ContractTermsGrid = ({ contract, isProviderView = false }: Props) => {
  return (
    <div className="mb-6">
      <h4 className="text-sm font-bold text-grey-50 mb-3">Contract Terms</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
        {contract.compType && <TermItem label="Comp Type" value={contract.compType} />}
        {contract.hourlyRate && <TermItem label="Rate" value={`$${contract.hourlyRate}/hr`} />}
        {contract.totalContractValue && (
          <TermItem label="Contract Value" value={formatCurrency(contract.totalContractValue)} />
        )}
        {!isProviderView && contract.numOfFtes != null && (
          <TermItem label="FTEs" value={contract.numOfFtes.toString()} />
        )}
        {!isProviderView && contract.numOfShifts != null && (
          <TermItem label="Total Shifts" value={contract.numOfShifts.toString()} />
        )}
        <TermItem
          label="Start Date"
          value={dateStringFormatter(contract.contractStartDate, 'STRING')}
        />
        <TermItem
          label="End Date"
          value={
            contract.contractEndDate
              ? dateStringFormatter(contract.contractEndDate, 'STRING')
              : 'Open-ended'
          }
        />
        <TermItem
          label="Duration"
          value={calculateDuration(contract.contractStartDate, contract.contractEndDate)}
        />
      </div>
    </div>
  );
};
